import axios from "axios";
import firebase from "config/firebase";
import { toast } from "react-toastify";
export const addNewsSuggestions =
  (Suggestions, onComplete = () => {}) =>
  (dispatch) => {
    let emailData = `
Story : ${Suggestions.type}
Explanation : ${Suggestions.remarks}
  `;
    const options = {
      to: "fanshelpplayersadmin@gmail.com",
      subject: "Response from Athlete",
      text: emailData,
    };

    axios
      .post(
        "https://us-central1-fans-help-players.cloudfunctions.net/app/sendUserEmail",
        options
      )
      .then(() => {
        onComplete();
        toast.success("Email Sent Successfully");
      });
  };
